import * as React from 'react';
const OnicofagiaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M113.7 78.77v5.39c0 7.58-6.13 13.71-13.7 13.71s-13.7-6.13-13.7-13.71v-5.39c0-5.05 6.13-9.14 13.7-9.14.48 0 .94.02 1.4.05l2.88 4.79 1.31-4.05c4.78 1.43 8.12 4.63 8.12 8.35ZM88.02 101.39c3.44 2.26 7.55 3.58 11.98 3.58s8.54-1.32 11.97-3.58"
      className="prefix__cls-1"
    />
    <path
      d="M111.97 133.17c-3.44-2.26-7.55-3.58-11.98-3.58s-8.54 1.32-11.97 3.58M106.38 137.51c-1.86-1.22-4.08-1.93-6.47-1.93s-4.61.71-6.47 1.93"
      className="prefix__cls-2"
    />
    <path
      d="M104.38 92.16c-1.26-.83-2.77-1.31-4.39-1.31s-3.13.48-4.39 1.31"
      className="prefix__cls-1"
    />
    <path
      d="M79.44 138.34V85.75c0-12.14 7.29-24.08 20.56-24.09 13.15 0 20.56 12.02 20.56 24.09v52.59"
      className="prefix__cls-2"
    />
  </svg>
);
export default OnicofagiaIcon;
